import { FlexBox, Tag, Tooltip } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';

import { conversationStatusAttributes } from 'utils/conversation/conversationAttributes';
import { useShortHumanReadableTimer } from 'utils/useShortHumanReadableTimer';

import { useConversationRow } from '../../../utils/useConversationRow';
import { ConversationsTableAgentPreferenceTooltip } from '../agentPreference/components/tooltip/conversationsTableAgentPreferenceTooltip';
import { getActiveAgentPreference } from '../agentPreference/conversationsTableAgentPreference.utils';

/** Represents the content of the status cell in the conversations table. */
export const ConversationsTableStatus = (): JSX.Element => {
  const {
    conversation: { status, pending_expiration_at, agent_preference },
  } = useConversationRow();

  const followUpTime = useShortHumanReadableTimer(pending_expiration_at);
  const agentPreference = getActiveAgentPreference(agent_preference);

  // NOTE: It appears that sometimes the status can be something that we don't
  // currently have recorded in the API types. While this is being investigated,
  // this should prevent the view from crashing and gracefully present a
  // fallback.
  if (
    status === null ||
    typeof conversationStatusAttributes[status] === 'undefined'
  ) {
    return <Tag color={colors.neutral['500']}>Unknown</Tag>;
  }

  const { label, color } = conversationStatusAttributes[status];
  const isPending = status === 'awaitingpending' || status === 'pending';
  const statusLabel = isPending ? 'Follow up' : label;

  return (
    <FlexBox alignItems="center" gap="250">
      <Tooltip
        content={`Follow up ${followUpTime}`}
        disabled={!pending_expiration_at}
      >
        <Tag color={color}>{statusLabel}</Tag>
      </Tooltip>

      {agentPreference && (
        <ConversationsTableAgentPreferenceTooltip
          agentPreference={agentPreference}
        />
      )}
    </FlexBox>
  );
};
